<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.406"
    height="11.008"
    viewBox="0 0 26.406 11.008"
  >
    <g transform="translate(-380.797 -395.452)">
      <path
        d="M399.319,406.46a20.906,20.906,0,0,1-4.455-.481,13.176,13.176,0,0,0-3.929-.754,25.6,25.6,0,0,0-2.8.169,20.8,20.8,0,0,1-2.842.15l-.168-.011a4.508,4.508,0,0,1-3.186-1.008c-.839-.8-1.035-1.129-1.107-1.865a3.136,3.136,0,0,1-.005-.85c.005-.358.1-2.849,1.941-3.626a6.808,6.808,0,0,1,2.413-.353,22.212,22.212,0,0,0,7.742-1.538c6.209-2.288,12.2.712,12.884,1.69a4.881,4.881,0,0,1,1.394,3.67c-.051,2.3-2.346,4.384-5.119,4.623A20.714,20.714,0,0,1,399.319,406.46Zm-8.6-2.238q.127,0,.249,0a13.9,13.9,0,0,1,4.172.8,19.986,19.986,0,0,0,6.831.262c2.263-.2,4.19-1.873,4.229-3.663a3.973,3.973,0,0,0-1.158-3c-.452-.6-5.924-3.551-11.775-1.392a23.437,23.437,0,0,1-8.051,1.6,6.149,6.149,0,0,0-2.061.273c-1.323.561-1.33,2.716-1.33,2.738l-.005.073a2.2,2.2,0,0,0,0,.623c.041.417.055.55.8,1.263.641.611,1.363.657,2.56.734l.169.011a20.779,20.779,0,0,0,2.684-.149C388.967,404.312,389.924,404.222,390.717,404.222Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
